// extracted by mini-css-extract-plugin
export var accordion = "_bs-0";
export var chevron = "_bs-3";
export var closed = "_bs-2";
export var content = "_bs-4";
export var open = "_bs-1";
export var rotate = "_bs-5";